import {z} from 'zod';
import {ELEMENT} from '../../elements/base/ElementTypes';
import {questionBaseValidator} from './questionBase';

export const yesNoQuestionV2Validator = questionBaseValidator.extend({
    type: z.literal(ELEMENT.YES_NO_QUESTION_V2),
});
